/** Dialog body copy for the new-chat confirm. Pure so tests can assert it
 *  without rendering: the base promise is constant, the destructive
 *  consequences are disclosed only when they exist. */
export const newChatConfirmBody = (isBuildInProgress: boolean, hasQueued: boolean): string => {
  const base =
    "The new chat starts with fresh context. The agent won't have access to " +
    "this conversation's history. Your flow stays as it is."
  if (isBuildInProgress && hasQueued) {
    return `${base} This will stop the build in progress and discard your queued messages.`
  }
  if (isBuildInProgress) return `${base} This will stop the build in progress.`
  if (hasQueued) return `${base} This will discard your queued messages.`
  return base
}
